module.exports = __webpack_public_path__ + "static/media/summit-download-link.0cd7980c.svg";